import styled from 'astroturf/react';
import { EiqButton } from 'eiq-storybook';
import Svg from 'src/components/Svg';

const ActionButton = styled('button')`
  font-size: var(--ph-required-indicate);
  margin-left: 5px;
  color: var(--dark-blue);
  cursor: pointer;

  &:hover {
    border-bottom: 1px solid var(--dark-blue);
  }
`;

const CancelButton = styled(EiqButton)`
  width: 80px !important;
  height: 28px !important;
  opacity: 1;
  text-align: center;
  font: normal normal bold 13px/15px var(--ph-font-family-lato-regular);
  letter-spacing: 0px;
  color: var(--dark-blue);
  opacity: 1;
  margin-right: 10px;
`;  

const CommentsSection = styled('div')`
  display: flex;
  width: 347px;
`;

const CommentTextArea = styled('div')`
  [class*='CommentInputWrapper'] {
    width: 100%;
    position: relative;
    margin-top: 15px;
    margin-bottom: 5px;

    textarea {
      border: 2px solid var(--ph-light-gray);
      resize: none;
    }
  }
`;

const Title = styled('h3')`
  font-family: var(--ph-font-family-lato-bold);
  font-size: var(--ph-heading-size);
  color: var(--dark-blue);
  padding-top: 7px;
    &[class*='desc-title'] {
      &::before {
        content: " ";
        height: 1em;
        width: 1em;
        clip-path: circle(2px at center);
        background-color: var(--cyan-green);
        display:inline-block;
        top: 2px;
        position: relative;
      }
    }
`;

const AddCommentIcon = styled(Svg)`
  width: 18px;
  top: 4px;
  left: 7px;
  cursor: pointer;
`;

const AddCommentInput = styled('div')`
  padding-top: 10px;

  [class*='editableText'] {
    padding-left: 10px !important;
  }
`;

const ButtonWrapper = styled('div')`
  padding-bottom: 10px;
`;

const Comment = styled('p')`
  padding-top: 10px;
  font-size: 11px;
  line-height: 15px;
  padding-left: 0px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
`;

const CommentDate = styled('span')`
  font-size: 11px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  position: relative;
  margin-left: 5px;
  color: var(--dark-black);
`;


const TitleSmall = styled('span')`
  font-family: var(--ph-font-family-lato-bold);
  color: var(--dark-blue);
  font-size: 11px;
  position: relative;
`;

const Separator = styled('span')`
  border-left: 0.5px solid var(--dark-black);
  margin-left: 5px;
  display: inline-block;
  height: 11px;
  margin-bottom: -2px;
`;

const SaveButton = styled(EiqButton)`
  width: 80px !important;
  height: 28px !important;
  background: var(--cyan-green) 0% 0% no-repeat padding-box !important;
  opacity: 1;
  text-align: center;
  font: normal normal bold 13px/15px var(--ph-font-family-lato-regular);
  letter-spacing: 0px;
  color: var(--dark-blue);
  opacity: 1;
`;

export default {
  ActionButton,
  ButtonWrapper,
  CancelButton,
  CommentsSection,
  CommentTextArea,
  Title,
  AddCommentIcon,
  AddCommentInput,
  Comment,
  CommentDate,
  TitleSmall,
  Separator,
  SaveButton,
}